-<template src="../../templates/form/milk-inspection-form.pug" lang="pug"></template>
<script>
import Modal from './Modal.vue'
import {mapActions, mapGetters, mapMutations} from 'vuex'
import { format } from 'date-fns'
import _filter from 'lodash/filter'
import _map from 'lodash/map'
import $axios from '../../axios'
import cyrillicToTranslit from 'cyrillic-to-translit-js'
import _each from "lodash/each"

export default {
    name: 'MilkInspectionForm',
    components: {
        Modal
    },
    props: ['milkInspectionToUpdate', 'milkResultsToUpdate'],
    data() {
        return {
            inspection: {
                id: null,
                milkingDate: null,
                results: []
            },
            loadingResult: false
        }
    },
    mounted() {
        this.inspection.id = this.milkInspectionToUpdate.id
        this.inspection.milkingDate = this.milkInspectionToUpdate.date
        this.inspection.results = this.milkResultsToUpdate
    },
    computed: {
        ...mapGetters(['animals', 'selectedFarm']),
        ...mapMutations(['addMilkResultToAnimal', 'addMilkInspection']),
        _milkInspection: {
            get() {
                return format(Date.now(), 'YYYY-MM-DD')
            },
            set(newVal) {
                this.inspection.milkingDate = Math.trunc(new Date(newVal).getTime() / 1000)
            }
        }
    },
    methods: {
        ...mapActions(['commitMilkInspection']),
        close() {
            this.$router.go(-1)
        },
        submit() {
            let self = this
            self.loadingResult = true
            this.commitMilkInspection(this.inspection).then(result => {
                self.$store.commit('addMilkResultToAnimals', result.milkResults)
                self.$store.commit('addMilkInspection', result.milkInspection)
            }).finally(() => {
                self.close()
                self.loadingResult = false
            })

        },
        removeResult(index) {
            this.inspection.results.splice(index, 1)
        },
        upload() {
            let formData = new FormData()
            formData.append('milking_results', this.$refs.file.files[0])
            let self = this
            $axios.post('/api/milkinspection/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }}).then(response => {
                self.inspection.milkingDate = Date.now()
                self.inspection.results = _filter(
                    _map(response.data.results, function(r) {
                        if (r.buckleNumber !== null && r.total !== null) {
                            return {
                                id: r.id,
                                buckleNumber: r.buckleNumber,
                                first: parseFloat(r.first),
                                second: parseFloat(r.second),
                                third: parseFloat(r.third),
                                total: parseFloat(r.total)
                            }
                        }
                    }),
                    undefined
                )
            })
        },
        download() {
            let filteredAnimals = _filter(this.animals, function(a) {
                return a.type === 'cow' && a.fecondity.state !== 'dried' && a.fecondity.state !== 'culled' && a.fecondity.state !== 'error'
            })
            let mappeddAnimals = _map(filteredAnimals, function(a) {
                    return {
                        id: a.id,
                        buckleNumber: a.buckleNumber,
                        fecondity: a.fecondity.state
                    }
            })
            $axios
                .post('/api/milkinspection/generate/' + this.selectedFarm.id, mappeddAnimals, {
                    headers: { Accept: 'application/vnd.ms-excel' },
                    responseType: 'blob'
                })
                .then(response => {
                    let farmNameLat = cyrillicToTranslit().transform(this.selectedFarm.name, '_')
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', '(model_milk)' + farmNameLat + '.xlsx')
                    document.body.appendChild(link)
                    link.click()
                })
        }
    }
}
</script>

<style lang="sass">
    @import '../../sass/mixin/color'
    @import '../../sass/mixin/flex'

    #milk-inspection-modal
        .modal-container
            height: 100vh
            width: 800px
            .modal-header
                background-color: $dd-light-orange
                color: white
            .modal-body
                height: calc(100vh - 48px - 96px)
                .loading-results
                    @include flexbox
                    @include justify-content(center)
                    @include align-content(center)
                form
                    overflow-y: auto
                    max-height: calc(100vh - 48px - 96px - 32px)
                    padding-right: 16px
                    .buttons-wrapper
                        @include flexbox
                        @include justify-content(center)
                        @include flex-direction(column)
                        .download, .upload
                            cursor: pointer
                            display: block
                            width: 100%
                            height: 48px
                            margin-bottom: 16px
                            @include flex-center
                            text-transform: uppercase
                            svg
                                margin-right: 8px
                            &:hover
                                span
                                    font-size: 18px
                        .download
                            background-color: $dd-strong-blue
                            color: white
                        .upload
                            position: relative
                            background-color: $c-tabe-lightgreen
                            input
                                cursor: pointer
                                width: 100%
                                height: 48px
                                position: absolute
                                z-index: 999
                                opacity: 0
                    .table-container
                        .table
                            margin-top: 16px
                            thead
                                background-color: $bleu-lighten
                                color: $text-color
                            tbody
                                tr
                                    th
                                        input
                                            max-width: 100px


</style>
